__turbopack_context__.v({
  "accent": "style-module-scss-module__zcgQAq__accent",
  "blink": "style-module-scss-module__zcgQAq__blink",
  "button": "style-module-scss-module__zcgQAq__button",
  "email": "style-module-scss-module__zcgQAq__email",
  "icon": "style-module-scss-module__zcgQAq__icon",
  "large": "style-module-scss-module__zcgQAq__large",
});
